import { useState as Q, useRef as q, useEffect as X, useMemo as E } from "react";
function oe(e, o) {
  for (var n = 0; n < o.length; n++) {
    const i = o[n];
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const v in i)
        if (v !== "default" && !(v in e)) {
          const f = Object.getOwnPropertyDescriptor(i, v);
          f && Object.defineProperty(e, v, f.get ? f : {
            enumerable: !0,
            get: () => i[v]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var Z = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function se(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var N = {}, L = {}, H;
function ue() {
  return H || (H = 1), L;
}
var I = {}, A = { exports: {} }, ce = A.exports, $;
function ae() {
  return $ || ($ = 1, function(e, o) {
    (function(n, i) {
      var v = {};
      n.PubSub ? (v = n.PubSub, console.warn("PubSub already loaded, using existing version")) : (n.PubSub = v, i(v)), e !== void 0 && e.exports && (o = e.exports = v), o.PubSub = v, e.exports = o = v;
    })(typeof window == "object" && window || ce || Z, function(n) {
      var i = {}, v = -1, f = "*";
      function S(t) {
        var s;
        for (s in t)
          if (Object.prototype.hasOwnProperty.call(t, s))
            return !0;
        return !1;
      }
      function c(t) {
        return function() {
          throw t;
        };
      }
      function h(t, s, u) {
        try {
          t(s, u);
        } catch (m) {
          setTimeout(c(m), 0);
        }
      }
      function y(t, s, u) {
        t(s, u);
      }
      function d(t, s, u, m) {
        var g = i[s], w = m ? y : h, O;
        if (Object.prototype.hasOwnProperty.call(i, s))
          for (O in g)
            Object.prototype.hasOwnProperty.call(g, O) && w(g[O], t, u);
      }
      function l(t, s, u) {
        return function() {
          var g = String(t), w = g.lastIndexOf(".");
          for (d(t, t, s, u); w !== -1; )
            g = g.substr(0, w), w = g.lastIndexOf("."), d(t, g, s, u);
          d(t, f, s, u);
        };
      }
      function T(t) {
        var s = String(t), u = !!(Object.prototype.hasOwnProperty.call(i, s) && S(i[s]));
        return u;
      }
      function C(t) {
        for (var s = String(t), u = T(s) || T(f), m = s.lastIndexOf("."); !u && m !== -1; )
          s = s.substr(0, m), m = s.lastIndexOf("."), u = T(s);
        return u;
      }
      function _(t, s, u, m) {
        t = typeof t == "symbol" ? t.toString() : t;
        var g = l(t, s, m), w = C(t);
        return w ? (u === !0 ? g() : setTimeout(g, 0), !0) : !1;
      }
      n.publish = function(t, s) {
        return _(t, s, !1, n.immediateExceptions);
      }, n.publishSync = function(t, s) {
        return _(t, s, !0, n.immediateExceptions);
      }, n.subscribe = function(t, s) {
        if (typeof s != "function")
          return !1;
        t = typeof t == "symbol" ? t.toString() : t, Object.prototype.hasOwnProperty.call(i, t) || (i[t] = {});
        var u = "uid_" + String(++v);
        return i[t][u] = s, u;
      }, n.subscribeAll = function(t) {
        return n.subscribe(f, t);
      }, n.subscribeOnce = function(t, s) {
        var u = n.subscribe(t, function() {
          n.unsubscribe(u), s.apply(this, arguments);
        });
        return n;
      }, n.clearAllSubscriptions = function() {
        i = {};
      }, n.clearSubscriptions = function(s) {
        var u;
        for (u in i)
          Object.prototype.hasOwnProperty.call(i, u) && u.indexOf(s) === 0 && delete i[u];
      }, n.countSubscriptions = function(s) {
        var u, m, g = 0;
        for (u in i)
          if (Object.prototype.hasOwnProperty.call(i, u) && u.indexOf(s) === 0) {
            for (m in i[u])
              g++;
            break;
          }
        return g;
      }, n.getSubscriptions = function(s) {
        var u, m = [];
        for (u in i)
          Object.prototype.hasOwnProperty.call(i, u) && u.indexOf(s) === 0 && m.push(u);
        return m;
      }, n.unsubscribe = function(t) {
        var s = function(R) {
          var p;
          for (p in i)
            if (Object.prototype.hasOwnProperty.call(i, p) && p.indexOf(R) === 0)
              return !0;
          return !1;
        }, u = typeof t == "string" && (Object.prototype.hasOwnProperty.call(i, t) || s(t)), m = !u && typeof t == "string", g = typeof t == "function", w = !1, O, k, M;
        if (u) {
          n.clearSubscriptions(t);
          return;
        }
        for (O in i)
          if (Object.prototype.hasOwnProperty.call(i, O)) {
            if (k = i[O], m && k[t]) {
              delete k[t], w = t;
              break;
            }
            if (g)
              for (M in k)
                Object.prototype.hasOwnProperty.call(k, M) && k[M] === t && (delete k[M], w = !0);
          }
        return w;
      };
    });
  }(A, A.exports)), A.exports;
}
var G;
function pe() {
  if (G) return I;
  G = 1, Object.defineProperty(I, "__esModule", {
    value: !0
  }), I.publishSticky = I.publish = I.unsubscribe = I.subscribe = void 0;
  var e = Object.assign || function(p) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var b in a)
        Object.prototype.hasOwnProperty.call(a, b) && (p[b] = a[b]);
    }
    return p;
  }, o = ae(), n = i(o);
  function i(p) {
    return p && p.__esModule ? p : { default: p };
  }
  function v(p) {
    if (Array.isArray(p)) {
      for (var r = 0, a = Array(p.length); r < p.length; r++)
        a[r] = p[r];
      return a;
    } else
      return Array.from(p);
  }
  var f = "@@psmb@@";
  Object.prototype.hasOwnProperty.call(n.default, f) || Object.defineProperty(n.default, f, {
    value: {
      stickyTopics: /* @__PURE__ */ new Set(),
      topicToEnvelopesMap: /* @__PURE__ */ new Map(),
      envelopeToConsumptionsMap: /* @__PURE__ */ new WeakMap(),
      topicToSubscriptionsCountMap: /* @__PURE__ */ new Map(),
      tokenToTopicMap: /* @__PURE__ */ new Map()
    },
    enumerable: !1,
    configurable: !1
  });
  var S = n.default[f].stickyTopics, c = n.default[f].topicToEnvelopesMap, h = n.default[f].envelopeToConsumptionsMap, y = n.default[f].topicToSubscriptionsCountMap, d = n.default[f].tokenToTopicMap, l = function(r, a) {
    return r === void 0 ? a : r;
  }, T = function(r) {
    return S.has(r);
  }, C = function(r) {
    S.add(r);
  }, _ = function(r) {
    var a = r.topic, b = l(c.get(a), []);
    b = T(a) ? [r] : [].concat(v(b), [r]), c.set(a, b), h.set(r, 0);
  }, t = function(r) {
    var a = c.get(r);
    return a && a[0];
  }, s = function(r) {
    var a = l(c.get(r), []);
    c.set(r, a.slice(1));
  }, u = function(r) {
    var a = l(t(r), {}), b = h.get(a), P = b + 1;
    return h.set(a, P), P;
  }, m = function(r) {
    return l(y.get(r), 0);
  }, g = function(r, a) {
    d.set(r, a);
  }, w = function(r) {
    var a = m(r);
    y.set(r, a + 1);
  }, O = function(r) {
    var a = l(d.get(r), ""), b = l(y.get(a), 0);
    y.set(a, b - 1);
  }, k = function(r, a) {
    return typeof r == "string" ? {
      topic: r,
      headers: {},
      data: a
    } : {
      topic: r.topic,
      headers: l(r.headers, {}),
      data: l(r.data, null)
    };
  }, M = function(r) {
    return {
      topic: String(r.topic),
      headers: l(r.headers, {}),
      data: r.data,
      timestamp: Date.now()
    };
  };
  I.subscribe = function(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
    }, b = void 0, P = void 0;
    if (typeof r == "string")
      b = r, P = a;
    else {
      var U = r;
      b = U.topic, P = function(W, ie) {
        var B = t(U.topic);
        B == null && (B = M(k(W, ie)), B.timestamp = 0, process.env.NODE_ENV !== "production" && console.warn('Message bus received an incompatible message on topic "' + W + '".\nIt means that the message has been published by old `@wh/message-bus@1.2` instance.\nDue to this reason, the `timestamp` field has been lost.')), U.callback(e({}, B, {
          data: l(B.data, null)
        }));
      };
    }
    w(b);
    var F = n.default.subscribe(b, function() {
      if (P.apply(void 0, arguments), !T(b)) {
        var x = u(b);
        x >= m(b) && s(b);
      }
    });
    return T(b) && setTimeout(function() {
      P(b, l(t(b), {}).data);
    }, 0), g(F, b), F;
  }, I.unsubscribe = function(r) {
    return O(r), n.default.unsubscribe(r);
  };
  var R = I.publish = function(r, a) {
    var b = M(k(r, a)), P = b.topic;
    return (m(P) > 0 || T(P)) && _(b), n.default.publish(b.topic, b.data);
  };
  return I.publishSticky = function(r, a) {
    return C(String(r)), R(String(r), a);
  }, I;
}
var V;
function le() {
  return V || (V = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.unsubscribe = e.publishSticky = e.subscribe = e.publish = void 0;
    var o = ue();
    Object.keys(o).forEach(function(d) {
      d === "default" || d === "__esModule" || Object.defineProperty(e, d, {
        enumerable: !0,
        get: function() {
          return o[d];
        }
      });
    });
    var n = pe(), i = v(n);
    function v(d) {
      if (d && d.__esModule)
        return d;
      var l = {};
      if (d != null)
        for (var T in d)
          Object.prototype.hasOwnProperty.call(d, T) && (l[T] = d[T]);
      return l.default = d, l;
    }
    var f = function(l) {
      return l.WH && l.WH.messageBus ? l.WH.messageBus : i;
    }(typeof window < "u" ? window : Z), S = f.publish, c = f.subscribe, h = f.publishSticky, y = f.unsubscribe;
    e.publish = S, e.subscribe = c, e.publishSticky = h, e.unsubscribe = y;
  }(N)), N;
}
var ee = le();
const fe = /* @__PURE__ */ se(ee), de = /* @__PURE__ */ oe({
  __proto__: null,
  default: fe
}, [ee]);
var be = "price", ve = "price-history", ye = "cashout_price", he = "handicap", Se = "is-in-play", me = "wh.push.ready", Y = "sports", J = "gtp-enhanced-odds";
function ge(e) {
  return function(n, i) {
    e.subscribe(n, function(v, f) {
      e.unsubscribe(n), i(f);
    });
  };
}
function Te(e) {
  var o = e.messageBus, n = e.readyTopic, i = e.operationSelector, v = new Promise(function(S) {
    ge(o)(n, S);
  }), f = {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    UNSUBSCRIBE_ALL: "unsubscribeAll"
  };
  return {
    subscribe: function(c) {
      return new Promise(function(h) {
        v.then(function() {
          var y;
          (y = i(f.SUBSCRIBE)) === null || y === void 0 || y(c), h();
        });
      });
    },
    unsubscribe: function(c) {
      return new Promise(function(h) {
        v.then(function() {
          var y;
          (y = i(f.UNSUBSCRIBE)) === null || y === void 0 || y(c), h();
        });
      });
    },
    unsubscribeAll: function(c) {
      return new Promise(function(h) {
        v.then(function() {
          var y;
          (y = i(f.UNSUBSCRIBE_ALL)) === null || y === void 0 || y(c), h();
        });
      });
    }
  };
}
function we(e) {
  return window.subscriptionManager[e];
}
var ne = Te({
  messageBus: de,
  operationSelector: we,
  readyTopic: me
}), te = ne.subscribe, re = ne.unsubscribe;
const Oe = ["name", "blurb", "marketGroupName"], K = "pushContainers.useSportPushUpdates";
function D(e, o = {}) {
  const [n, i] = Q(
    {}
  ), v = q(o);
  v.current = o;
  const f = q(
    (S) => (c) => {
      i((h) => {
        var g, w;
        const y = j(S), d = h[y] ?? {}, l = ((w = (g = v.current) == null ? void 0 : g.handler) == null ? void 0 : w.call(g, c)) ?? c, { eventId: T, marketId: C, selectionId: _, ...t } = S, s = Object.keys(t);
        let u = !1;
        const m = { ...d };
        for (const O of s)
          O in l && !Oe.includes(O.toString()) && (m[O] = l[O], u = !0);
        return u ? {
          ...h,
          [y]: m
        } : h;
      });
    }
  );
  return X(() => {
    const S = [];
    i((c) => {
      const h = e.map(j), y = Object.keys(c), d = {};
      let l = !1;
      for (const T of y)
        h.includes(T) ? d[T] = c[T] : l = !0;
      return l ? d : c;
    });
    for (const c of e) {
      const h = {
        eventId: c.eventId,
        marketId: c.marketId,
        selectionId: c.selectionId,
        callback: f.current(c)
      };
      te({
        type: Y,
        owner: K,
        ...h
      }), S.push(h);
    }
    return () => {
      for (const c of S)
        re({
          type: Y,
          owner: K,
          ...c
        });
    };
  }, [e]), E(
    () => e.map((S) => {
      const c = j(S);
      return n[c] != null ? {
        ...S,
        ...n[c]
      } : S;
    }),
    [e, n]
  );
}
function j(e) {
  return `${e.eventId}_${e.marketId}_${e.selectionId}`;
}
function _e(e) {
  return D(
    E(
      () => e.map((o) => ({ ...o, eventId: o.id })),
      [e]
    ),
    E(() => ({ handler: Ie }), [])
  );
}
function Be(e) {
  const o = E(() => [e], [e]);
  return _e(o)[0];
}
function Ie(e) {
  switch (e.type) {
    case Se:
      return { isInPlay: e.value };
    default: {
      const { type: o, ...n } = e;
      return n;
    }
  }
}
function ke(e) {
  return D(
    E(
      () => e.map((o) => ({ ...o, marketId: o.id })),
      [e]
    ),
    E(() => ({ handler: Pe }), [])
  );
}
function Ae(e, o) {
  const n = E(
    () => [{ ...e, eventId: o ?? e.eventId }],
    [e, o]
  );
  return ke(n)[0];
}
function Pe(e) {
  switch (e.type) {
    case he:
      return { hcapValue: e.value };
    default: {
      const { type: o, ...n } = e;
      return n;
    }
  }
}
function Ee(e) {
  return D(
    E(
      () => e.map((o) => ({
        ...o,
        selectionId: o.id
      })),
      [e]
    ),
    E(() => ({ handler: Ce }), [])
  );
}
function Re(e, o, n) {
  const i = E(
    () => [
      {
        ...e,
        eventId: o ?? e.eventId,
        marketId: n ?? e.marketId
      }
    ],
    [e, o, n]
  );
  return Ee(i)[0];
}
function Ce(e) {
  switch (e.type) {
    case be: {
      const { numerator: o, denominator: n } = e, i = {};
      return o != null && (i.currentPriceNum = o), n != null && (i.currentPriceDen = n), i;
    }
    case ye: {
      const { cashoutNumerator: o, cashoutDenominator: n } = e, i = {};
      return o != null && (i.cashoutPriceNum = o), n != null && (i.cashoutPriceDen = n), i;
    }
    case ve: {
      const { priceHistory: o } = e;
      return {
        priceHistory: (o == null ? void 0 : o.split("|")) ?? []
      };
    }
    default: {
      const { type: o, ...n } = e;
      return n;
    }
  }
}
const z = "pushContainers.useSelectionWasPriceSubscription", Ue = (e, o, n, i = { num: null, den: null }) => {
  const [v, f] = Q(i);
  return X(() => {
    const S = ({ data: c }) => {
      var y, d, l, T, C;
      const h = (C = (T = (l = (d = (y = c == null ? void 0 : c.markets) == null ? void 0 : y.find((_) => _.id === o)) == null ? void 0 : d.selections) == null ? void 0 : l.find((_) => _.id === e)) == null ? void 0 : T.prices) == null ? void 0 : C.find((_) => _.name === "WAS");
      h && f({ num: h.priceNum, den: h.priceDen });
    };
    return te({
      type: J,
      owner: z,
      eventId: n,
      callback: S
    }), () => {
      re({
        type: J,
        owner: z,
        eventId: n,
        callback: S
      });
    };
  }, [e, o, n]), v;
};
export {
  Be as useEventSubscription,
  _e as useEventSubscriptionList,
  Ae as useMarketSubscription,
  ke as useMarketSubscriptionList,
  Re as useSelectionSubscription,
  Ee as useSelectionSubscriptionList,
  Ue as useSelectionWasPriceSubscription
};
